import { Heading, Text } from '@backend/lib-design-system';
import type { PropsWithChildren } from 'react';
import { styled } from 'styled-components';

import { Column } from '~/components/Column';
import { Container } from '~/components/Container/Container';
import { Link } from '~/components/Link';
import { sanitize } from '~/utils/sanitize';

const StyledSEOContainer = styled(Container)<{ $withBackground?: boolean }>`
  background-color: ${({ $withBackground, theme }) => ($withBackground ? theme.palette.grey100 : 'white')};
`;

const StyledSEOTitle = styled(Heading)`
  text-align: center;

  span {
    color: ${({ theme }) => theme.colors.primary.normal};
  }
`;

const StyledSEOTitleLink = styled(Link)`
  text-decoration: none;
`;

const StyledSEOSectionList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SEOContainer = ({ children, withBackground }: PropsWithChildren<{ withBackground?: boolean }>) => (
  <StyledSEOContainer $withBackground={withBackground}>
    <Column>{children}</Column>
  </StyledSEOContainer>
);

export const SEOTitle = ({ content }: { content: string }) => (
  <StyledSEOTitle
    variant="heading-2"
    dangerouslySetInnerHTML={{
      __html: sanitize(content),
    }}
  />
);

export const SEOTitleWithLink = ({ content, href }: { content: string; href: string }) => (
  <StyledSEOTitleLink href={href}>
    <StyledSEOTitle
      variant="heading-2"
      dangerouslySetInnerHTML={{
        __html: sanitize(content),
      }}
    />
  </StyledSEOTitleLink>
);

export const SEOText = ({ content }: { content: string }) => (
  <Text
    variant="body-light"
    dangerouslySetInnerHTML={{
      __html: sanitize(content),
    }}
  />
);

export const SEOSectionTitle = ({ content }: { content: string }) => (
  <Heading
    variant="heading-4"
    dangerouslySetInnerHTML={{
      __html: sanitize(content),
    }}
  />
);

export const SEOSectionList = ({ children }: PropsWithChildren) => (
  <StyledSEOSectionList>{children}</StyledSEOSectionList>
);

export const SEOSectionListItem = ({ content }: { content: string }) => <SEOText content={`• ${content}`}></SEOText>;
